import React from 'react';
import ServiceItem from './ServiceItem';

const ServicesList = ({ services }) => {
  return (
    <div className="px-4 lg:px-12">
      {services.map((service, index) => (
        <ServiceItem key={service.id} service={service} index={index} />
      ))}
    </div>
  );
};

export default ServicesList;
